import Client from "./_client";

const ieltsClientId = process.env.REACT_APP_IELTS_CLIENT_ID;

export const generateMock = async ({ type, sections = [], attemptId, short }) => {
    let url = "/mockSection/generate-mock?";

    if (attemptId) url += `&attempt=${attemptId}`;
    if (type) url += `&type=${type}`;
    if (sections) url += `&sections=${sections}`;
    if (short) url += `&short=${short}`;

    const result = await new Client({ path: url }).get();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! cannot generate the mock. Please try again!"
        );
    }

    return result?.data;
};

export const getMockDetails = async (id) => {
  let url = `/mockSection/template/${id}`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! failed to fetch mock. Please try again!"
    );
  }else{
    return result?.data;
  }
};

export const getMockSections = async (payload) => {

  const result = await new Client({
    path: `/mockSection/template/to-be-attempted`,
    payload
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! unable fetch mock template. Please try again!"
    );
  }

  return result?.data;
}

/**
 * Every templates query is scoped to the B2C IELTS client. The backend takes
 * that client id under the `user` query param, not `client`.
 *
 * The scoping lives here rather than at the call sites because the dashboard
 * names tests by their position in these results (see buildTestNameIndex in
 * MockTestHistory) — a call site that forgot the filter would silently
 * renumber the history rows.
 */
export const getMockTemplates = async (filters) => {
  let url = '/mockSection/templates?';

  const query = ieltsClientId ? { ...filters, user: ieltsClientId } : filters;

  Object.keys(query).forEach((key) => url += `${key}=${query[key]}&`);

  const result = await new Client({ path: url }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! unable to fetch mock templates. Please try again!"
    );
  }

  return result?.data;
};